import React, { useState, useEffect, Fragment } from "react";
import { AxiosRequestConfig } from "axios";
import { connect } from "react-redux";
import { onStartDownloadImage } from "../../appRedux/actions";
import CircularProgress from "../CircularProgress";
import { Avatar } from "antd";
import { IFetchtImage } from "../../interfaces";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";

function FetchtImage(props: IFetchtImage) {
  const [objectUrl, setObjectUrl] = useState<null | string>("");
  const [err, setErr] = useState(false);

  useEffect(() => {
    async function getImage(url: string) {
      let http = await FaraGostarDynamicHttp();

      try {
        const config: AxiosRequestConfig = {
          responseType: "blob",
        };

        let result = await http.get(url, config);

        var reader = new FileReader();

        if (props.setImageData) {
          reader.readAsDataURL(result.data);
          reader.onloadend = function () {
            var base64String = reader.result;

            if (props.setImageData) return props.setImageData(base64String);
          };
        }

        const objUrl = URL.createObjectURL(result.data);

        setObjectUrl(objUrl);
      } catch (err) {
        setErr(true);
      }
    }
    getImage(props.src);

    return () => {
      setObjectUrl(null);
    };
  }, [props.src]);

  useEffect(() => {
    if (objectUrl) return URL.revokeObjectURL(objectUrl);
  }, [objectUrl]);

  // if (err) {
  //   return (
  // <div className={`gx-modal-box-avatar gx-mx-2 ${props.className}`}>
  //   <Avatar size="large" src={require("assets/images/placeholder.jpg")} />
  // </div>
  //   );
  // }

  return (
    <div
      className={`gx-d-flex gx-flex-row gx-justify-content-center gx-align-items-center ${props.parentClassName}`}
    >
      <div className="gx-w-20">
        {objectUrl ? (
          <img
            alt={props.alt ? props.alt : "fetch-image"}
            className={props.className}
            src={objectUrl}
          />
        ) : (
          <Fragment>
            {props.defaultImage ? (
              <img
                alt={props.alt ? props.alt : "fetch-image"}
                className={props.className}
                src={props.defaultImage}
              />
            ) : (
              <div className={`gx-modal-box-avatar gx-mx-2 ${props.className}`}>
                <Avatar
                  size="large"
                  src={require("assets/images/placeholder.jpg")}
                />
              </div>
            )}
          </Fragment>
        )}
      </div>
      <div className="gx-w-80">
        {props.text ? (
          <span>
            {" "}
            {props.text} <br />
            {/* <span className="gx-text-grey gx-fs-xs"> {props.sentDateTime}</span> */}
          </span>
        ) : (
          <span></span>
        )}
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: any) => ({
  onStartDownloadImage: (imageSrc: string) =>
    dispatch(onStartDownloadImage(imageSrc)),
});

export default connect(null, mapDispatchToProps)(FetchtImage);
